import { Component, OnInit, Input } from "@angular/core";
import { NavParams, ViewController, AlertController, LoadingController, ToastController, ModalController } from "ionic-angular";
import { FormBuilder, FormGroup, Validators, ValidatorFn } from "@angular/forms";
import { AlertMessager } from '../../../lib/alertMessager';
import {
    ChangeRequestStatus,
    RegistrationChangeRequest,
    RegistrationChangeRequestDocument,
    RegistrationChangeRequestReleaseCount,
    TurnoutContestant,
    TurnoutReason,
    PaymentBalanceRequired,
    ChangeRequestHelper
 } from "../../../model/registration-change-request";
import { Organization } from "../../../model/organization";
import { Rodeo } from "../../../model/rodeo";
import { RodeoEvent } from "../../../model/rodeoEvent";
import { RodeoEventRegistration } from "../../../model/rodeoEventRegistration";
import { RodeoEventRun } from "../../../model/rodeoEventRun";
import { Account } from "../../../model/account";
import { EntryService } from "../../../services/entry.service";
import { RodeoService } from "../../../services/rodeo.service";
import { RequestService } from "../../../services/request.service";
import { ImageService } from "../../../services/image.service";
import { UserService } from "../../../services/user.service";
import { UserManager } from "../../../services/managers/user.manager";
import { Subscription } from "rxjs";
import { DatePipe } from "@angular/common";
import { PurchaseOrder } from "../../../model/purchase-order";
import { PaymentService } from "../../../services/payment.service";
import { AuditHistoryPage } from "../audit-history/audit-history";

@Component({
    selector: 'change-request-details',
    templateUrl: 'change-request-details.html'
})
export class ChangeRequestDetailsComponent implements OnInit {
    entry: RodeoEventRegistration;
    run: RodeoEventRun;
    organization: Organization;
    rodeo: Rodeo;
    rodeoEvent: RodeoEvent;
    changeRequest: RegistrationChangeRequest;
    isEditing: boolean;
    isNewRequest: boolean;

    dataLoaded: boolean = false;
    didSave: boolean = false;

    subscriptions: Subscription[] = [];    

    order: PurchaseOrder;

    /*
        CHANGE REQUEST - GENERAL
    */
    errorMessage: string;

    maxDocReleases: number = 0;
    maxVetReleases: number = 0;
    contestantsReleases: any[] = [];

    currentUser: any;

    reviewedByAccount: Account = new Account();
    
    /*
        CHANGE REQUEST - DETAILS
    */
    changeForm: FormGroup;
    statuses = ChangeRequestStatus;

    turnoutReasonAndPotOptions: any[] = [
        {reason: 'Turnout', moneyInPot: true},
        {reason: 'Doctor Release', moneyInPot: false},
        {reason: 'Vet Release', moneyInPot: false},
        {reason: 'Drawout', moneyInPot: false},
        {reason: 'Notified Turnout', moneyInPot: true},
        {reason: 'Non-Notified Turnout', moneyInPot: true},
        {reason: 'Visible Injury', moneyInPot: true},
    ]

    turnoutStatusOptions: any[] = [
        'Pending',
        'Under Review',
        'Approved Pending Pay',
        'Completed',
        'Denied',
        'Cancelled',
        'Error Applying Changes',
        'Reversed',
    ]

    requestDocuments: RegistrationChangeRequestDocument[] = [];

    previousReason: TurnoutReason;
    selectedReason: any = '';
    selectedStatus: any = '';
    isMoneyInPot: boolean = false;

   /*
        COMMENT VARIABLES
    */
  
    commentOptions: any[] = [
        { label: 'Staff Responses (External)', formControlName: 'staffResponses', previousValue: '', editedValue: '', isEditing: false, isUpdated: false},
        { label: 'Staff Comments (Internal)', formControlName: 'staffComments', previousValue: '', editedValue: '', isEditing: false, isUpdated: false},
        { label: 'Contestant Comments', formControlName: 'contestantComments', previousValue: '', editedValue: '', isEditing: false, isUpdated: false},
    ];

    newCommentHeader: string;
    showCommentsBox = false;
    formattedDate = new Date().toISOString().slice(0, 22);


    /*
        FEES
    */
    currentUserIsAdmin: boolean = false;
    entryFeeCost: number;
    newEntryCost: number = 0;
    selectedFeeReason: boolean = false;

    schedule: any;
    entryPrefScheduleIds: any[] = [];
    runHasPrefScheduleId: boolean = false;

    previousAppliedFeeOption: any;
    previousFeeAmount: number = 0;
    selectedFeeAmount: number = 0;

    turnoutFees: any[] = [
        {label: 'Doc Release Fine', formControlName: 'turnoutFeeDoctorsRelease', isApplied: false, initialValue: 0},
        {label: 'Vet Release Fine', formControlName: 'turnoutFeeVetRelease', isApplied: false, initialValue: 0},
        {label: 'NTO Fine', formControlName: 'turnoutFeeNotified', isApplied: false, initialValue: 0},
        {label: 'NNTO Fine', formControlName: 'turnoutFeeNonNotified', isApplied: false, initialValue: 0},
        {label: 'NTO Perf Fine', formControlName: 'turnoutFeeNotifiedPerformance', isApplied: false, initialValue: 0},
        {label: 'NNTO Perf Fine', formControlName: 'turnoutFeeNonNotifiedPerformance', isApplied: false, initialValue: 0},
        {label: 'NTO Non Pref Fine', formControlName: 'turnoutFeeNotifiedNonPreference', isApplied: false, initialValue: 0},
        {label: 'NNTO Non Pref Fine', formControlName: 'turnoutFeeNonNotifiedNonPreference', isApplied: false, initialValue: 0},
        {label: 'NTO Slack Fine', formControlName: 'turnoutFeeNotifiedSlack', isApplied: false, initialValue: 0},
        {label: 'NNTO Slack Fine', formControlName: 'turnoutFeeNonNotifiedSlack', isApplied: false, initialValue: 0}
    ]

    popoverActive: boolean = false

    constructor(
        private navParams: NavParams,
        private viewCtrl: ViewController,
        private fb: FormBuilder,
        private entryService: EntryService,
        private alertController: AlertController,
        private alert: AlertMessager,
        private loadingController: LoadingController,
        private rodeoService: RodeoService,
        private requestService: RequestService,
        private toast: ToastController,
        private imageService: ImageService,
        private userService: UserService,
        private userManager: UserManager,
        private datePipe: DatePipe,
        private paymentService: PaymentService,
        private modalCtrl: ModalController) {
        }

    async ngOnInit() {
        if (!this.entry) { this.entry = this.navParams.get('entry'); }
        if (!this.run) { this.run = this.navParams.get('run'); }
        if (!this.rodeoEvent) { this.rodeoEvent = this.navParams.get('rodeoEvent'); }
        if (!this.changeRequest) { this.changeRequest = this.navParams.get('changeRequest'); }
        if (!this.rodeo) { this.rodeo = this.navParams.get('rodeo'); }
        if (!this.organization) {
            this.organization = this.navParams.get('organization');

            if (!this.organization && this.rodeo) {
                this.organization = this.rodeo.organization;
            }
        }
        if (!this.isEditing) { this.isEditing = this.navParams.get('isEditing'); }
        if (!this.isNewRequest) { this.isNewRequest = this.navParams.get('isNewRequest'); }
        if (!this.order) { this.order = this.navParams.get('order'); }

        this.subscriptions.push(this.userManager.account.subscribe(account => {
            this.currentUser = account as Account;
            // console.log('user', this.currentUser);
        }));

        await this.initVariables();
        this.initForm();
        this.dataLoaded = true;
    }

    ionViewWillLeave() {
        for(let i = 0; i < this.subscriptions.length; i++) {
            let subscription = this.subscriptions[i];

            if (!subscription.closed)
                subscription.unsubscribe();
        }
    }

    async reverseTurnout() {
        this.changeForm.get('status').patchValue(ChangeRequestStatus.Reversed);
        this.save();
    }

    async save(proceedToPay: boolean = false) {
        // console.log('information to save', this.changeForm.value);
        let loading = this.loadingController.create({
            content: 'Saving Turnout Request...',
        });

        if (this.changeForm.get('turnoutReason').value === this.changeForm.get('turnoutOverride').value) {
            this.changeForm.get('turnoutOverride').patchValue(null);
        }

        // When the reversed button is hidden, and the status is still reversed in the form...
        if (this.changeForm.get('status').value === ChangeRequestStatus.Reversed) {
            let didConfirmReverse = await this.reverseTurnoutPrompt();

            if (!didConfirmReverse) {
                // Reset turnout reason to previous reason
                this.changeForm.get('turnoutReason').patchValue(this.previousReason);
                // Reset selectedReason
                this.selectedReason = this.turnoutReasonAndPotOptions[this.previousReason].reason;
                // console.log('selected reason reset to previous', this.selectedReason);
                // Resets the appropriate fee fields
                this.turnoutFees.forEach((x) => {
                    x.isApplied = x.initialValue > 0;
                    this.changeForm.get(x.formControlName).patchValue(x.initialValue);
                });
                return;
            } else {
                this.turnoutFees.forEach((x) => {
                    x.isApplied = false;
                    this.changeForm.get(x.formControlName).patchValue(0);
                });

                this.changeForm.get('entryCostTurnoutAdjustment').patchValue(0);
            }
        }

        // Need to set all other unApplied turnout fee fields to 0
        this.turnoutFees.forEach((x) => { if (!x.isApplied) this.changeForm.get(x.formControlName).patchValue(0) });

        try {
            loading.present();

            const request: any = await this.requestService.saveTurnoutRequest(this.changeForm.value, this.entry.run
                ? this.entry.run.id : this.run ? this.run.id : null);
            
            if (request) {
                // console.log('returned request', request);
               
                this.entry = request.registration;
                this.entry.run = request.registration.run ? request.registration.run : null;

                this.paymentService.getOrder(this.entry.purchaseOrderId).then((order) => {
                    this.order = order;
                });

                loading.dismiss();
                this.changeRequest = request;
                this.didSave = true;

                this.close();
                this.customToast('Successfully saved turnout request!', 'success');

                if (proceedToPay) {
                    const paymentUrl = `https://nextgendemo.z19.web.core.windows.net/rodeos/payments/orders/${this.entry.purchaseOrderId}?rodeoId=${this.rodeo.id}`;
                    window.open(paymentUrl, '_blank'); 
                }
            }
        }
        catch (error) {
            loading.dismiss();
            this.didSave = false;

            console.log('Saving Error', error);

            this.changeForm.get('status').setValue(this.changeRequest.status);
            this.alert.showError("Saving Error", error);
        }
    }

    close() {
        const data = {
            request: this.changeRequest,
            order: this.order,
            // Do we need to pass back entry? If so, on save, should we be retrieving updated entry from db, or back as attached DTO to updated request?
            didSave: this.didSave
        }
        this.viewCtrl.dismiss(data);
    }

    getRequestStatusLabel() {
        let status = ChangeRequestStatus[this.changeRequest.status];
        if (status) {
            status = status.replace(/([A-Z])/g, ' $1');
            if (this.changeRequest.status == ChangeRequestStatus.Pending) {
                status += this.changeRequest.isTurnoutRequest ? ' - TURNOUT' : ' - CHANGE'
            }
        }
        return status;
    }

    getTurnoutStatusLabel() {
        let status = TurnoutReason[this.changeRequest.turnoutReason];
        if (status) {
            status = status.replace(/([A-Z])/g, ' $1');
        }
        return status;
    }

    getStatusLabelColor(request) {
        switch(request.status) {
            case ChangeRequestStatus.Completed:
            case ChangeRequestStatus.ApprovedPendingPayment:
                return 'secondary';
            default:
                return 'danger';
        }
    }

    getTurnoutContestantLabel() {
        if ((this.changeForm.value.turnoutContestant == TurnoutContestant.Header && !this.entry.teammateHeader)
            || (this.changeForm.value.turnoutContestant == TurnoutContestant.Heeler && this.entry.teammateHeader)) {
            return this.entry.contestantOne ? `${this.entry.contestantOne.firstName} ${this.entry.contestantOne.lastName}` : 'Contestant One';
        } else {
            return this.entry.contestantTwo ? `${this.entry.contestantTwo.firstName} ${this.entry.contestantTwo.lastName}` : 'Contestant Two';
        }
    }

    addRequestDocument(fileList) {
        if (fileList && fileList.length > 0) {
            let fileToUpload = fileList.item(0);

            const docCount = this.changeRequest.documents ? this.changeRequest.documents.length : 0;
            const fileName =  `${this.changeRequest.registrationId}_TurnoutRequest_${this.changeRequest.turnoutReason === TurnoutReason.DoctorRelease
            ? 'Doc_Note'
              : (this.changeRequest.turnoutReason === TurnoutReason.VetRelease
                ? 'Vet_Note' : '')}_${docCount + 1}.jpeg`;
            
            // TODO: Add check for file type
            this.imageService.uploadImage(fileToUpload, fileName, false)
                .then(() => {
                    const newDoc = new RegistrationChangeRequestDocument();
                    newDoc.url = `https://nextgenrodeomedia.blob.core.windows.net/images/${fileName}`;

                    // console.log('newDoc', newDoc);
                    this.addDocument(newDoc);
                }).catch(error => {
                    console.log('Error saving image: ' + error || error.errorMessage || error.message);
                    this.alert.showError("Image Error", error);
                });
        }
    }
      
    addDocument(document: RegistrationChangeRequestDocument | undefined) {
        this.changeRequest.documents.push(document);

        const documents = this.changeForm.controls['documents'];
        documents.patchValue([...this.changeRequest.documents]);
    }
      
    removeRequestDocument(index: number) {
          this.changeRequest.documents.splice(index, 1);
    }

    updateTurnoutReason(value?: any) {
        let index = value ? Number(value) : this.changeForm.get('turnoutOverride').value;

        if (index) {
            this.selectedReason = this.turnoutReasonAndPotOptions[index].reason;
            this.isMoneyInPot = this.turnoutReasonAndPotOptions[index].moneyInPot;   
            this.updateAppliedFee(index);
        }
    }

    // Step 1: Clicking 'Add' next to field
    initializeNewComment(option: any) {
        const date = new Date().toISOString();
        const formattedDate = this.datePipe.transform(date, 'medium');

        option.isEditing = true;
        option.editedValue = `${formattedDate}: ${this.currentUser.firstName} ${this.currentUser.lastName} - `;
    }

    // Step 2: When typing in the available comment box, updating the appropriate variable
    updateNewCommentText(option: any, event: any) {
        option.editedValue = option.editedValue.concat(event.value);
    }

    // Step 3: Click 'Add' and compile new comments with the header (date and name)
    addComment(option: any) {        
        const control = this.changeForm.get(option.formControlName);
    
        if (control) {
            if (option.previousValue) {
                control.patchValue(`${option.previousValue}\n${option.editedValue}`)
            } else {
                control.patchValue(option.editedValue);
            }
        
            option.isEditing = false;
            option.isUpdated = true;
        }
    }

    resetCommentText(option: any) {    
        const control = this.changeForm.get(option.formControlName);

        if (option.previousValue) {
            control.patchValue(option.previousValue);
        } else {
            control.patchValue(null)
        }

        option.editedValue = '';
        option.isUpdated = false;
    }

    closeCommentsBox(option: any) {    
        option.isEditing = false;
        option.editedValue = null;

        if (this.newCommentHeader !== '') { this.newCommentHeader = '' }
    }

    updateEntryCostAdjustment(event: any) {
        const value = event ? Number(event.value) : 0;
        const difference = this.entryFeeCost - value;
        this.changeForm.get('entryCostTurnoutAdjustment').patchValue(difference);
        // console.log('cost adjustment', this.changeForm.get('entryCostTurnoutAdjustment').value);
    }

    async viewRequestLogs() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;

        let config = [{ entityName: 'RegistrationChangeRequest', entityId: this.changeRequest.id }];

        let logModal = this.modalCtrl.create(AuditHistoryPage,
            {
                config: config,
                pageTitle: 'Change Request'
            },
            { cssClass: 'page-entry-logs', enableBackdropDismiss: false });

        logModal.present();
        logModal.onDidDismiss((data) => {
            this.popoverActive = false;
        });
    }

    private updateAppliedFee(value: TurnoutReason) {
        let turnoutOption = this.setFeeOption(value);

        if (turnoutOption) {
            for (let option of this.turnoutFees) {
                option.isApplied = option.formControlName === turnoutOption.formControlName;
            }
        } else {
            for (let option of this.turnoutFees) {
                option.isApplied = false;
                this.changeForm.get(option.formControlName).patchValue(0);
            }
        }
    }

    private setReleaseCounts(): void {
        let contestantIds = [];

        if (this.entry && !contestantIds.includes(this.entry.contestantOneId)) {
            contestantIds.push(this.entry.contestantOneId);
        }

        if (this.entry && this.entry.contestantTwoId && !contestantIds.includes(this.entry.contestantTwoId)) {
            contestantIds.push(this.entry.contestantTwoId);
        }

        for (const id of contestantIds) {
            const orgId = this.organization ? this.organization.id : this.rodeo ? this.rodeo.organization.id : null;
            this.requestService.getUserReleaseRequests(id, orgId).then((data: any) => {
                if (data) {
                    data = {
                        organizationId: data.organizationId,
                        doctorReleaseCount: data.doctorReleaseCount,
                        vetReleaseCount: data.vetReleaseCount,
                        firstName: id === this.entry.contestantOneId ? this.entry.contestantOne.firstName : this.entry.contestantTwo.firstName,
                        lastName: id === this.entry.contestantOneId ? this.entry.contestantOne.lastName : this.entry.contestantTwo.lastName,
                    };
                    this.contestantsReleases.push(data);
                    // console.log('contestant releases', data);
                }
            });
        }
    }

    private setFeeOption(reason: TurnoutReason) {
        let turnoutFee = undefined;
        let defaultValue = 0;

        if (reason === TurnoutReason.DoctorRelease) {
            defaultValue = this.organization.turnoutFeeDoctorsRelease;
            turnoutFee = this.turnoutFees.find(option => option.formControlName === 'turnoutFeeDoctorsRelease');
        } else if (reason === TurnoutReason.VetRelease) {
            defaultValue = this.organization.turnoutFeeVetRelease;
            turnoutFee = this.turnoutFees.find(option => option.formControlName === 'turnoutFeeVetRelease');
        } else if (reason === TurnoutReason.NotifiedTurnout || reason === TurnoutReason.NonNotifiedTurnout) {
            const isSlack = this.schedule.name.toLowerCase().includes('slack');
            const isNotified = reason === TurnoutReason.NotifiedTurnout;

            if (this.run && this.runHasPrefScheduleId && !isSlack) {
                defaultValue = isNotified ?
                    this.organization.turnoutFeeNotifiedPerformance : this.organization.turnoutFeeNonNotifiedPerformance;
                turnoutFee = this.turnoutFees.find(option => option.formControlName === (isNotified ? 'turnoutFeeNotifiedPerformance' : 'turnoutFeeNonNotifiedPerformance'));
    
            } else if (this.run && isSlack) {
                defaultValue = isNotified ?
                    this.organization.turnoutFeeNotifiedSlack : this.organization.turnoutFeeNonNotifiedSlack;
                turnoutFee = this.turnoutFees.find(option => option.formControlName === (isNotified ? 'turnoutFeeNotifiedSlack' : 'turnoutFeeNonNotifiedSlack'));
    
            } else if (this.run && !this.runHasPrefScheduleId) {
                defaultValue = isNotified ?
                    this.organization.turnoutFeeNotifiedNonPreference : this.organization.turnoutFeeNonNotifiedNonPreference;
                turnoutFee = this.turnoutFees.find(option => option.formControlName === (isNotified ? 'turnoutFeeNotifiedNonPreference' : 'turnoutFeeNonNotifiedNonPreference'));
    
            } else if (!this.run){
                defaultValue = isNotified ? this.organization.turnoutFeeNotified : this.organization.turnoutFeeNonNotified;
                turnoutFee = this.turnoutFees.find(option => option.formControlName === (isNotified ? 'turnoutFeeNotified' : 'turnoutFeeNonNotified'));
            }
        }
        
        if (turnoutFee) {
            this.changeForm.get(turnoutFee.formControlName).patchValue(turnoutFee.initialValue > 0 ? turnoutFee.initialValue : defaultValue);
            this.selectedFeeReason = true;
        } else {
            this.selectedFeeReason = false;
        }

        return turnoutFee;
    }

    private setReviewedByAccount(accountId: number) {
        this.userService.getAccount(accountId).then((data: any) => {
            this.reviewedByAccount = data;
            // console.log('reviewedByAccount', data);
        });
    }

    private async initVariables() {
        // First check entry for schedules to set pref ids and first pref as schedule
        if (this.entry) {
            if (this.entry.schedules.length > 0) {
                this.entryPrefScheduleIds = this.entry.schedules.map((schedule) => schedule.scheduleId);
            } else if (this.entry.scheduleIds && this.entry.scheduleIds.length > 0) {
                this.entryPrefScheduleIds = this.entry.scheduleIds;
            }

            if (this.entryPrefScheduleIds.length > 0) {
                this.schedule = this.rodeoEvent.schedules.find(x => x.id === this.entryPrefScheduleIds[0]);
            }
        }

        // Then check run to override the current assigned schedule
        // Check that run was assigned to a entry pref
        if (this.run) {
            this.runHasPrefScheduleId = this.entryPrefScheduleIds.some((id) => id === this.run.rodeoEventScheduleId);
            this.schedule = this.rodeoEvent.schedules.find((schedule) => schedule.id === this.run.rodeoEventScheduleId);
        }

        // If there are no prefs on entry, then default to first rodeoEvent schedule
        if (!this.schedule && this.rodeoEvent) {
            this.schedule = this.rodeoEvent.schedules[0];
        }

        // console.log('schedule', this.schedule);

        if (this.changeRequest) {
            if (!this.changeRequest.documents) {
                this.changeRequest.documents = [];
            }

            // TODO: After API cleanup, remove this
            if (this.changeRequest.turnoutReason === TurnoutReason.Turnout) {
                if (this.errorMessage !== '') {
                    this.changeRequest.turnoutReason = TurnoutReason.NonNotifiedTurnout;
                } else {
                    this.changeRequest.turnoutReason = TurnoutReason.NotifiedTurnout;
                }
            }
        } else {
            this.changeRequest = ChangeRequestHelper.create();
            this.addNewRequestDefaultValues();
            this.isNewRequest = true;
        }

        this.commentOptions.forEach((option) => {
            option.previousValue = this.changeRequest[option.formControlName] || undefined;
        });

        // console.log('selected', this.changeRequest);

        this.selectedReason = this.turnoutReasonAndPotOptions[this.changeRequest.turnoutReason].reason;
        this.selectedStatus = this.turnoutStatusOptions[this.changeRequest.status];
        this.previousReason = this.changeRequest.turnoutReason;
       
        this.turnoutFees.forEach((x) => {
            x.initialValue = this.changeRequest[x.formControlName] || 0;
        });

        if (this.rodeoEvent) {
            // Only set to adjustment if undefined
            if (!this.changeRequest.entryCostTurnoutAdjustment) {
                this.changeRequest.entryCostTurnoutAdjustment = 0;
            }
        }

        if (!this.changeRequest.reviewedById) {
            this.changeRequest.reviewedById = this.currentUser.id;
            this.changeRequest.reviewedOn = new Date().toISOString();
        }
        
        if (this.organization) {
            this.maxDocReleases = this.organization ? this.organization.maxContestantDoctorReleaseTurnoutsPerSeason
                : this.rodeo.organization.maxContestantDoctorReleaseTurnoutsPerSeason;
            this.maxVetReleases = this.organization ? this.organization.maxContestantVetReleaseTurnoutsPerSeason
                : this.rodeo.organization.maxContestantVetReleaseTurnoutsPerSeason;
            
            let cutOffDate = new Date(this.schedule ? this.schedule.scheduledDate : this.rodeoEvent.schedules[0].scheduledDate);
            cutOffDate.setHours(cutOffDate.getHours() - this.organization.turnoutGraceDeadlineHours);

            if (this.rodeoEvent && new Date() >= cutOffDate)
            {
                let date = this.datePipe.transform(this.rodeoEvent.schedules[0].scheduledDate, 'medium')
                this.errorMessage = `The turnout grace deadline has passed: ${date}.`

                if (this.isNewRequest) {
                    this.changeRequest.turnoutReason = TurnoutReason.NonNotifiedTurnout;
                }
            }
        }
        
        if (!this.order && this.entry.purchaseOrderId && this.entry.purchaseOrderId > 0) {
            const order = await this.paymentService.getOrder(this.entry.purchaseOrderId);
            this.order = order;
            // console.log('order', this.order);
        } 

        if (this.order) {
            let entryItem = this.order.lineItems.find(x => (x.productType === 'JackpotEntry' || x.productType === 'RodeoEntry')
            && x.entityIds.includes(this.entry.id.toString()));
                
            if (!entryItem) {
                entryItem = this.order.lineItems.filter(x => (x.productType === 'JackpotEntry' || x.productType === 'RodeoEntry'))[0];
            }
            // console.log('entry item', entryItem);
            // console.log('entry item cost', entryItem.unitPrice);
            this.entryFeeCost = entryItem.unitPrice;
            this.newEntryCost = entryItem.unitPrice - entryItem.amountRefunded - entryItem.turnoutAdjustmentAmount;
        } else if (this.rodeoEvent.priceTiers && this.rodeoEvent.priceTiers.some(x => x.isActive)) {
            var priceTier = this.rodeoEvent.priceTiers.filter(x => x.isActive)[0];

            this.entryFeeCost = priceTier.unitPrice;
            this.newEntryCost = priceTier.unitPrice; 
        } else {
            this.entryFeeCost = this.rodeoEvent.entryCost;
            this.newEntryCost = this.rodeoEvent.entryCost; 
        }

        if (this.currentUser && this.currentUser.roles.some(x => (x.roleId >= 5 && x.organizationId === this.rodeo.organization.id) || x.roleId >= 6)) {
            this.currentUserIsAdmin = true;
            // console.log('roles', this.currentUser.roles);
            // console.log('isSuperAdmin', this.currentUserIsAdmin);
        }
    }

    private updateAdjustmentAmount() {
        const rodeoType = this.rodeo.isJackpot ? 'JackpotEntry' : 'RodeoEntry';

        if (this.order) {
            const entryItem = this.order.lineItems.find(x => x.productType === rodeoType && x.rodeoEventId == this.entry.rodeoEventId);

            if (entryItem) {
                this.changeForm.get('entryCostTurnoutAdjustment').patchValue(entryItem.turnoutAdjustmentAmount);
            }
        }
    }

    private initForm() {
        this.changeForm = this.fb.group({
            id: this.changeRequest.id,
            status: this.isEditing ? this.changeRequest.status : ChangeRequestStatus.ApprovedPendingPayment,
            contestantComments: this.changeRequest.contestantComments,
            staffComments: this.changeRequest.staffComments,
            staffResponses: this.changeRequest.staffResponses,
            paymentBalanceRequired: this.isEditing ? this.changeRequest.paymentBalanceRequired : PaymentBalanceRequired.FullBalance,
            turnoutReason: this.changeRequest.turnoutReason,
            turnoutOverride: this.changeRequest.turnoutOverride,
            turnoutContestant: this.isEditing ? this.changeRequest.turnoutContestant : TurnoutContestant.FullEntry,
            turnoutDocumentUrl: this.changeRequest.turnoutDocumentUrl,
            documents: [this.changeRequest.documents],
            isStaffResponse: true,
            isTurnoutRequest: true,
            rodeoId: this.changeRequest.rodeoId,
            organizationId: this.changeRequest.organizationId,
            registrationId: this.changeRequest.registrationId,
            createdOn: this.changeRequest.createdOn,
            requestedById: this.changeRequest.requestedById,
            reviewedOn: this.changeRequest.reviewedOn,
            reviewedById: this.changeRequest.reviewedById,
            modifiedOn: this.changeRequest.modifiedOn,
            completedOn: this.changeRequest.completedOn,
            turnoutFeeDoctorsRelease: [this.changeRequest.turnoutFeeDoctorsRelease, this.createFineValidators(this.organization.turnoutFeeDoctorsRelease)],
            turnoutFeeVetRelease: [this.changeRequest.turnoutFeeVetRelease, this.createFineValidators(this.organization.turnoutFeeVetRelease)],
            turnoutFeeNotified: [this.changeRequest.turnoutFeeNotified, this.createFineValidators(this.organization.turnoutFeeNotified)],
            turnoutFeeNonNotified: [this.changeRequest.turnoutFeeNonNotified, this.createFineValidators(this.organization.turnoutFeeNonNotified)],
            turnoutFeeNotifiedPerformance: [this.changeRequest.turnoutFeeNotifiedPerformance, this.createFineValidators(this.organization.turnoutFeeNotifiedPerformance)], 
            turnoutFeeNonNotifiedPerformance: [this.changeRequest.turnoutFeeNonNotifiedPerformance, this.createFineValidators(this.organization.turnoutFeeNonNotifiedPerformance)],
            turnoutFeeNotifiedNonPreference: [this.changeRequest.turnoutFeeNotifiedNonPreference, this.createFineValidators(this.organization.turnoutFeeNotifiedNonPreference)],
            turnoutFeeNonNotifiedNonPreference: [this.changeRequest.turnoutFeeNonNotifiedNonPreference, this.createFineValidators(this.organization.turnoutFeeNonNotifiedNonPreference)],
            turnoutFeeNotifiedSlack: [this.changeRequest.turnoutFeeNotifiedSlack, this.createFineValidators(this.organization.turnoutFeeNotifiedSlack)],
            turnoutFeeNonNotifiedSlack: [this.changeRequest.turnoutFeeNonNotifiedSlack, this.createFineValidators(this.organization.turnoutFeeNonNotifiedSlack)],
            entryCostTurnoutAdjustment: [this.changeRequest.entryCostTurnoutAdjustment, [
                Validators.required,
                Validators.min(0),
                Validators.max(this.entryFeeCost)
              ]],
        });

        if (this.changeRequest.turnoutReason && !this.changeRequest.turnoutOverride) {
            this.changeForm.get('turnoutOverride').setValue(this.changeRequest.turnoutReason);
        }

        const reviewedById = this.changeForm.get('reviewedById').value;
        if (reviewedById) { this.setReviewedByAccount(reviewedById); }

        this.setReleaseCounts();
        this.updateAdjustmentAmount();
        this.updateTurnoutReason();
    }

    private createFineValidators(maxValue: number): ValidatorFn[] {
        return [
          Validators.required,
          Validators.min(0),
          Validators.max(maxValue)
        ];
      }

    private addNewRequestDefaultValues() {
        this.changeRequest.registrationId = this.entry ? this.entry.id : 0;
        this.changeRequest.organizationId = this.organization ? this.organization.id : this.rodeo ? this.rodeo.organization.id : 0;
        this.changeRequest.rodeoId = this.rodeo ? this.rodeo.id : this.rodeoEvent ? this.rodeoEvent.rodeoId : 0;
        this.changeRequest.requestedById = this.entry ? this.entry.contestantOneId : 0;
    }

    private reverseTurnoutPrompt() {
        let title = 'Turnout Reversal';
        let message = 'Are you sure you want to reverse this turned out request?';
        
        return new Promise<boolean>((resolve, reject) => {
            let alert = this.alertController.create({
                title: title,
                message: message,
                buttons: [
                    {
                        text: 'Yes',
                        handler: () => {
                            resolve(true);
                        }
                    },
                    {
                        text: 'No',
                        role: 'cancel',
                        handler: () => {
                            resolve(false);
                        }
                    }]
            });
            alert.present();
        });
    }

    private customToast(message: string, color: string) {
        this.toast.create({
            message: message,
            cssClass: color === 'success'
                ? 'successDisplay' : color === 'danger'
                    ? 'dangerDisplay' : color === 'warning'
                    ? 'warningDisplay' : 'defaultDisplay',
            duration: 5000,
            position: 'bottom'
        }).present();
    }

    showPermissionsAlert() {
        let title = 'Account Permissions';
        let message = 'You do not currently have the permissions to access these fields.';
        
        return new Promise<boolean>((resolve, reject) => {
            let alert = this.alertController.create({
                title: title,
                message: message,
                buttons: [
                    {
                        text: 'Ok',
                        handler: () => {}
                    },
                ]
            });
            alert.present();
        });
    }
}


// WEBPACK FOOTER //
// ./src/pages/staff/change-requests/change-request-details.ts